export enum FeeFormulaTiers {
    'FROM_AMOUNT' = 'FEE_FORMULA_TIERS-FROM_AMOUNT',
    'TO_AMOUNT'='FEE_FORMULA_TIERS-TO_AMOUNT',
    'FIXED_FEE' = 'FEE_FORMULA_TIERS-FIXED_FEE',
    'PERCENTAGE' = 'FEE_FORMULA_TIERS-PERCENTAGE',
};
